import {
  getScoreColor,
  getScoreLevel,
  ScoreLevels,
} from 'utils/scores/scores-utils';
import {TrendDirection} from 'utils/number/trend';

export const mapColors = {
  v2: {
    high: 'rgba(52, 199, 89, 0.4)',
    low: 'rgba(199, 52, 52, 0.4)',
    medium: 'rgba(255, 204, 0, 0.4)',
  } as Record<ScoreLevels, string>,
  v3: {
    high: '#34C75999',
    low: '#FF154E99',
    medium: 'transparent',
  } as Record<ScoreLevels, string>,
  v4: {
    high: '#34C75999',
    low: '#FF154E99',
    medium: '#FDCA40CC',
  } as Record<ScoreLevels, string>,
};

// Trend text colour by direction. Flat inherits the surrounding text colour:
// "no change" is not a verdict.
export const trendColors: Record<TrendDirection, string | undefined> = {
  up: mapColors.v3.high,
  down: mapColors.v3.low,
  flat: undefined,
};

// The solid score colour (IT-2274): the one shared rule in scores-utils.
export const getProgressBarColor = (percentage: number) =>
  getScoreColor(percentage);

export const getProgressBarColor2 = (percentage: number) => {
  const level = getScoreLevel(percentage);
  return mapColors.v2[level];
};

export const getProgressBarColor3 = (percentage: number) => {
  const level = getScoreLevel(percentage);
  return mapColors.v3[level];
};

export const getProgressBarColor4 = (percentage: number) => {
  const level = getScoreLevel(percentage);
  return mapColors.v4[level];
};
